export default __webpack_public_path__ + "static/media/Heissluftballon-mit-Maus.3cb370f1.webp";